import { useAtomValue, useSetAtom } from 'jotai'
import { useEventEmitter, useTar } from "@/modules"
import { ToggleGroup, ToggleGroupItem, cn } from '@duck/ui'
import { workspaceLayoutAtom } from '@/store/workspaceAtoms'

export const WorkspaceLayoutToggle = () => {
    const { t } = useTar()
    const workspaceLayout = useAtomValue(workspaceLayoutAtom)
    const setWorkspaceLayout = useSetAtom(workspaceLayoutAtom)
    const emitWorkspaceRepaintSolution = useEventEmitter('workspace:repaintSolution', 10)

    return (
        <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground mr-2">
                {t('challenges.workspaceLayout')}:
            </span>
            <ToggleGroup
                type="single"
                value={workspaceLayout}
                className="flex items-center gap-1  p-1"
                onValueChange={(value) => {
                    if (value) {
                        setWorkspaceLayout(value as 'split-top' | 'split-side')
                        emitWorkspaceRepaintSolution({})
                    }
                }}
            >
                <ToggleGroupItem
                    value="split-top"
                    aria-label="Split top layout"
                    className={cn(
                        "h-8 w-8 p-0 min-w-8",
                        "data-[state=on]:bg-transparent data-[state=on]:text-primary",
                        "data-[state=off]:text-muted-foreground",
                        "hover:bg-primary/50",
                        "[&_svg]:size-6 [&_svg]:shrink-0"
                    )}
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        className="transition-colors"
                    >
                        <rect x="3" y="3" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
                        <rect x="13" y="3" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
                        <rect x="3" y="13" width="18" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
                    </svg>
                </ToggleGroupItem>
                <ToggleGroupItem
                    value="split-side"
                    aria-label="Split side layout"
                    className={cn(
                        "h-8 w-8 p-0 min-w-8",
                        "data-[state=on]:bg-transparent data-[state=on]:text-primary",
                        "data-[state=off]:text-muted-foreground",
                        "hover:bg-primary/50",
                        "[&_svg]:size-6 [&_svg]:shrink-0"
                    )}
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        className="transition-colors"
                    >
                        <rect x="3" y="3" width="8" height="18" rx="1" stroke="currentColor" strokeWidth="1.5" />
                        <rect x="13" y="3" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
                        <rect x="13" y="13" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
                    </svg>
                </ToggleGroupItem>
            </ToggleGroup>
        </div>
    )
}


